<template>
    <div class="honor">
        <div class="top-img">
            <img width="100%" :src="topic.cover_img" alt />
        </div>
        <div class="box" v-for="item in list"  @click="handleDetail(item)">
            <img class="honor-img" :src="item.cover_img[0]" alt />
            <div class="pages" v-if="item.type==2">共{{item.cover_img.length}}张</div>
            <div class="title">{{ item.title }}</div>
        </div>
        <div class="global-back">
            <img src="/static/third/detail_back_btn.svg" @click="goDetail" alt="">
        </div>
    </div>
</template>

<script>
import {ImagePreview} from 'vant';
import Interface from "@/util/interface"
import listSkeleton from "@/skeleton/listSkeleton"

export default {
    name: 'course-list',
    components: {
        'list-skeleton': listSkeleton,
    },
    data() {
        return {
            topic_id: 0,

            value: "",
            active: "",
            category_id: 0,
            category_index: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            loading: true,
            topic: {},
            nav_active: 0,
            from_name: "",
        }
    },
    methods: {
        fetchTopic() {
            Interface.getData('get', Interface.topic.detail + this.$route.params.topic_id).then((res) => {
                this.topic = res.data

                let title = ""
                this.topic.modules.forEach(val => {
                    if (val.key == "honorary") {
                        title += val.title
                    }
                })
                let desc = ""
                switch (this.topic.id) {
                    case 2:
                        desc = "一站式解锁诊断技术发展动态，行业专家亲身传授，与数万名同道共成长"
                        break
                    default:
                        desc = this.topic.desc
                        break
                }

                Interface.getShareInfo(this, this.topic.title + "-" + title, this.topic.cover_img, desc)
            })
        },
        fetch(scene) {
            if (scene === 'list') {
                let params = {
                    page: 1,
                    pageSize: 999,
                    meeting_subject_id: this.$route.params.topic_id
                }
                Interface.getData('get', Interface.topic.honor, params).then((res) => {
                    if (res.code == 0) {
                        if (res.data.list) {
                            this.list = res.data.list
                        } else {
                            this.list = []
                        }
                    }
                    setTimeout(() => {
                        this.loading = false;
                    }, 500)
                })
            } else if (scene === 'banner') {
                let params = {
                    meeting_subject_id: this.$route.params.topic_id
                }
                Interface.getData('get', Interface.topic.honor_banner, params).then((res) => {
                    if (res.code == 0) {
                        this.banners = res.data
                    }
                })
            }
        },
        changeCategory() {
            this.category_id = this.categories[this.category_index].id
            this.fetch('list')
        },
        goBytx() {
            if (this.$route.params.topic_id == 1) {
                //location.href = "https://bytx.care-gobroad.com/#/live-column/246"
            }
        },
        handleDetail(row) {
            if(row.type == 1){
                this.$router.push({
                    name: "topic-honor-detail",
                    params: {
                        topic_id: this.$route.params.topic_id,
                        id: row.id
                    }
                })
            }else{
                ImagePreview(row.cover_img)
            }
        },
        goDetail() {
            this.$router.push({
                name: "topic-detail",
                params: {
                    id: this.$route.params.topic_id
                }
            })
        }
    },
    created() {
        this.fetch('list')
        this.fetch('banner')
        this.fetchTopic()
        sessionStorage.removeItem("search_data")
    },
}
</script>
<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/honor/index/index.vue